import { z } from 'zod';
import { InspectionSchema } from '../entities/inspection.js';
import { InspectionsServiceEventBaseSchema, inspectionsServiceEventType } from './service.js';
const inspectionEventType = (eventName) => inspectionsServiceEventType('inspection', eventName);
export const InspectionEventSchema = InspectionsServiceEventBaseSchema.extend({
    inspection: InspectionSchema,
});
export const InspectionCreatedEventSchema = InspectionEventSchema.extend({
    type: inspectionEventType('created'),
    schemaVersion: z.literal(1),
});
export const InspectionStartedEventSchema = InspectionEventSchema.extend({
    type: inspectionEventType('started'),
    schemaVersion: z.literal(1),
});
export const InspectionEndedEventSchema = InspectionEventSchema.extend({
    type: inspectionEventType('ended'),
    schemaVersion: z.literal(1),
});
export const InspectionUpdatedEventSchema = InspectionEventSchema.extend({
    type: inspectionEventType('updated'),
    schemaVersion: z.literal(1),
});
export const InspectionCompletedEventSchema = InspectionEventSchema.extend({
    type: inspectionEventType('completed'),
    schemaVersion: z.literal(1),
    metadata: InspectionsServiceEventBaseSchema.shape.metadata.and(z.object({
        requestActor: z.string().optional(),
    })),
});
export const InspectionDeletedEventSchema = InspectionEventSchema.extend({
    type: inspectionEventType('deleted'),
    schemaVersion: z.literal(1),
});
